import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Clock, LogOut } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-secondary/40 px-6" data-testid="pending-screen">
      <div className="w-full max-w-md rounded-2xl border border-border bg-white p-8 text-center shadow-sm">
        <Logo className="mx-auto mb-6 h-10" />
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
          <Clock className="h-7 w-7 text-amber-600" />
        </div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-foreground">Awaiting approval</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Thanks {user?.name || "there"} — your account has been created and is waiting for an administrator to approve access
          {user?.suggested_site ? <> for <strong>{user.suggested_site}</strong></> : null}.
          You'll be able to sign in and see your site's data once you're approved.
        </p>
        {user?.department && (
          <p className="mt-3 text-xs text-muted-foreground">Microsoft department: <strong>{user.department}</strong></p>
        )}
        <Button variant="outline" className="mt-6 w-full" onClick={logout} data-testid="pending-logout-btn">
          <LogOut className="mr-2 h-4 w-4" /> Sign out
        </Button>
      </div>
    </div>
  );
}
